<form [formGroup]="typologyForm">
  <mat-form-field>
    <mat-select (selectionChange)="onChange($event.value)" placeholder="Zoning code" formControlName="zoningCode">
      <mat-option (change)="onChange($event)" *ngFor="let zoningCode of zoningCodes" [value]="zoningCode">
        {{zoningCode.Name}}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field>
    <mat-select multiple placeholder="Typology" [required]="true" formControlName="selectedTypologies">
      <mat-option class="all" (click)="selectAll()" [value]="selectedAll">All Typologies</mat-option>
      <mat-option *ngFor="let typology of typologies" [value]="typology">
        {{typology.Name}}
      </mat-option>
    </mat-select>
  </mat-form-field>
</form>
